import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';

import { Style } from '../../../../Common/Styles/models/style.model';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { StylesService } from '../../../../Common/Styles/services/styles.service';
import { MonitoringTextStyleModel } from '../../models/monitoring-text-style.model';
import { BriefingStyleStateEnum } from '../../../../Common/MonitorShared/enum/briefing-style-state.enum';
import { SaveTwigTemplateDialogComponent } from '../../../../Common/Dialogs/components/SaveTwigTemplateDialog/save-twig-template-dialog.component';
import { styleTypeApiEnumToBriefingBlockTypeEnum } from '../../../Briefings/enums/briefing-block-type.enum';
import { Template } from '../../../../Common/Styles/models/template.model';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { TextStyleFieldComponent } from '../../../../Common/PageBuilder/components/TextStyleField/text-style-field.component';
import { TextStyleFieldModel } from '@Common/PageBuilder/models/text-style-field.model';
import { MonitoringTitleStyleModel } from '@Monitor/Shared/models/monitoring-title-style.model';
import { MonitoringTitleFieldModel } from '@Monitor/Shared/models/monitoring-title-field.model';
import { BriefingHeadingLevelEnum } from '@Monitor/Briefings/enums/briefing-heading-level.enum';
import { TextStyleDefaultsModel } from '@Common/PageBuilder/models/text-style-defaults.model';
import { BlockDisplayTypeEnum } from '../../../../Common/PageBuilder/enums/block-display-type.enum';

@Component({
    selector: 'agpr-briefing-title-style-field',
    templateUrl: './briefing-title-style-field.component.html',
    styleUrls: ['./briefing-title-style-field.component.scss'],
    standalone: false
})
export class BriefingTitleStyleFieldComponent extends TextStyleFieldComponent implements OnInit, OnDestroy, OnChanges {
    @Input() declare value: MonitoringTitleStyleModel;
    @Input() hidePadding: boolean = false;
    @Input() field: MonitoringTitleFieldModel;

    @Output() changes: EventEmitter<MonitoringTitleStyleModel> = new EventEmitter<MonitoringTitleStyleModel>();

    headingTwoField: TextStyleFieldModel;
    headingTwo: MonitoringTextStyleModel;

    headingThreeField: TextStyleFieldModel;
    headingThree: MonitoringTextStyleModel;

    constructor(
        protected coreDialogService: CoreDialogService,
        protected stylesService: StylesService,
        protected briefingsService: AbstractPageBuilderService
    ) {
        super(coreDialogService, stylesService, briefingsService);
    }


    ngOnInit(): void {
        if (this.block?.displayElement) {
            this.field.allowExpertMode = this.block?.displayElement?.displayType !== BlockDisplayTypeEnum.ONLINE;
        }

        if (!this.value) {
            this.value = new MonitoringTitleStyleModel();
        }

        super.ngOnInit();

        this.headingTwoField = new MonitoringTitleFieldModel(
            'headingTwo',
            false,
            new TextStyleDefaultsModel(
                '22px',
                '#5e6473',
                true
            ),
            `Briefings.title.headingLevel.style.${BriefingHeadingLevelEnum.HEADING_2}`,
        );

        this.headingThreeField = new MonitoringTitleFieldModel(
            'headingThree',
            false,
            new TextStyleDefaultsModel(
                '20px',
                '#5e6473',
                true
            ),
            `Briefings.title.headingLevel.style.${BriefingHeadingLevelEnum.HEADING_3}`
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        this.headingTwo = this.value.headingTwo;
        this.headingThree = this.value.headingThree;
    }

    /**
     * Opens the save-twig-template-dialog after loading the data needed for it
     */
    public saveExpertTemplate(): void {
        if (!this.styleModel) {
            this.styleModel = new Style();
        }

        this.styleModel.style = this.value;
        this.styleModel.template = this.value.template;
        this.saveTwigTemplateDialogModel.inputs.defaultTemplate = this.briefingsService.getDefaultTemplateByBlockType(
            styleTypeApiEnumToBriefingBlockTypeEnum.get(this.field.styleType),
            BriefingStyleStateEnum.BRIEFING_1
        );
        // Set the default template if there's not a template on this style already
        if (!this.styleModel.template) {
            this.setTemplate = true;
            this.styleModel.template = new Template();
            this.styleModel.template.template = this.saveTwigTemplateDialogModel.inputs.defaultTemplate;
        }

        this.saveTwigTemplateDialogModel.inputs.type = this.field.styleType;
        this.saveTwigTemplateDialogModel.inputs.inputStyle = this.styleModel;
        this.coreDialogService.open(SaveTwigTemplateDialogComponent, this.saveTwigTemplateDialogModel);
    }

    protected updateStyleFromSavedStyle() {
        if (!this.value || !this.styles || !Number(this.value.styleState)) {
            return;
        }

        const savedStyle: Style = this.styles.find(x => x.id === this.value.styleState as number);
        if (!savedStyle) {
            // the list doesn't contain the id we're looking for, can't load it
            return;
        }
        const textStyleModel = new MonitoringTitleStyleModel(savedStyle.style);
        textStyleModel.styleState = this.value.styleState;
        textStyleModel.displayStyleState = this.value.displayStyleState;
        textStyleModel.template = savedStyle.template;

        this.value = textStyleModel;
    }
}
